import { deriveVehicleScheduleContext } from '@/app/utils/vehicleScheduleContext';
import type { Vehicle } from '@features/vehiclesearch/types/vinvrmsearch.types';
import type { VehicleDerivative } from '@features/vehiclesearch/types/manualsearch.types';
import { resolveVrm } from './resolveVrm';

// The three values a vendor session is confirmed against; a change in any of them
// leaves the session describing a vehicle the dealer is no longer quoting.
export const smriqSessionVehicleKey = (
    vehicle: Vehicle | VehicleDerivative | null | undefined,
): string => {
    const { vehicleMileage, annualMileage } = deriveVehicleScheduleContext(vehicle);

    return [resolveVrm(vehicle) ?? '', vehicleMileage ?? '', annualMileage ?? ''].join('|');
};
